import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "transfer-options__param" };
const _hoisted_2 = { class: "transfer-options__label" };
const _hoisted_3 = { class: "transfer-options__value" };
const _hoisted_4 = {
    key: 1,
    class: "transfer-options__value-hidden"
};
import { ref } from 'vue';
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import CopyToClipboard from "@astina/paloma-common-ui/src/components/CopyToClipboard.vue";
import GenerateShopImportProfilePassword from "../commands/GenerateShopImportProfilePassword";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImportProfileInputPassword',
    props: {
        profile: {}
    },
    setup(__props) {
        const props = __props;
        const generatePassword = new GenerateShopImportProfilePassword(props.profile.id);
        const newPassword = ref(null);
        function onGeneratePassword(response) {
            newPassword.value = response.newPassword;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('import_profile.transfer.password')), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    (newPassword.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(newPassword.value) + " ", 1),
                            _createVNode(CopyToClipboard, {
                                value: newPassword.value,
                                discreet: true
                            }, null, 8, ["value"])
                        ], 64))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('import_profile.transfer.password_hidden')), 1))
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (_unref(generatePassword))
                    ? (_openBlock(), _createBlock(CommandButton, {
                        key: 0,
                        command: _unref(generatePassword),
                        onSuccess: onGeneratePassword,
                        classes: ['button', 'button--link']
                    }, null, 8, ["command"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
